import { css } from '@emotion/core';

export const root = css`
  position: relative;
  z-index: 1;
`;

export const nav = css`
  a.LinkWithRef:focus {
    box-shadow: none;
  }
`;

export const logoWidth = css`
  width: 100px;
`;

export const avatar = { borderRadius: '50%', cursor: 'default', width: 24, height: 24 };

export const searchStyles = css`
  position: relative;
  input {
    padding-right: 36px; // for the button
  }
  button {
    position: absolute;
    top: 2px;
    right: 11px;
    margin: 0;
  }
  // atlaskit search component adds this role and an extra 20px margin
  & > div[role='search'] {
    margin-left: 0;
  }
`;
